/**
 * Global
 *
 * The main file, page logic which is needed on all pages will be included here.
 * Please note for specific components like a slider create a separated components/<component_name>.js
 * The components will be loaded through the component loader and are not needed on every page!
 */

document.addEventListener('DOMContentLoaded', () => {
  $(document).ready(function () {
    $(document).on('click', '.js-page-scroll a', function () {
      const href = $(this).attr('href');
      try {
        const url = new URL(href);
        const sectionId = url.hash;
        scrollToSection(sectionId);
      } catch (e) {
        console.error(`Invalid URL: ${href}`);
      }
    });

    // Check if the URL has a hash fragment when the page loads
    const urlHash = window.location.hash;
    if (urlHash) {
      scrollToSection(urlHash);
    }

    // Handle the hashchange event
    $(window).on('hashchange', function () {
      const urlHash = window.location.hash;
      if (urlHash) {
        scrollToSection(urlHash);
      }
    });
  });
  function scrollToSection(sectionId) {
    const section = $(sectionId);
    $('html, body').animate({
      scrollTop: section.offset().top
    }, 800, function () {
      // After scrolling, find the .e-n-accordion-item-title and trigger a click
      const accordionTitle = section.find('.e-n-accordion-item-title');
      if (accordionTitle.attr('aria-expanded') === 'false') {
        accordionTitle.click();
      }
    });
  }
});